__turbopack_context__.v({
  "navigationProgress": "z-u9dq_navigationProgress",
});
